module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "750px",
      "margin": "0 auto",
      "border": "1px solid",
      "box-shadow": "5px 5px 5px #888888"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "650px",
      "margin": "0 auto"
    },
    attrs: {
      "id": "content"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt"
    }
  }, [_vm._m(3), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.year
    },
    model: {
      value: (_vm.contract.year),
      callback: function($$v) {
        _vm.$set(_vm.contract, "year", $$v)
      },
      expression: "contract.year"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("年")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.month
    },
    model: {
      value: (_vm.contract.month),
      callback: function($$v) {
        _vm.$set(_vm.contract, "month", $$v)
      },
      expression: "contract.month"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("月")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.day
    },
    model: {
      value: (_vm.contract.day),
      callback: function($$v) {
        _vm.$set(_vm.contract, "day", $$v)
      },
      expression: "contract.day"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("日")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("共同签署：")])], 1), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.Bname
    },
    model: {
      value: (_vm.contract.Bname),
      callback: function($$v) {
        _vm.$set(_vm.contract, "Bname", $$v)
      },
      expression: "contract.Bname"
    }
  })], 1), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("甲乙双方于")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.year1
    },
    model: {
      value: (_vm.contract.year1),
      callback: function($$v) {
        _vm.$set(_vm.contract, "year1", $$v)
      },
      expression: "contract.year1"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("年")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.month1
    },
    model: {
      value: (_vm.contract.month1),
      callback: function($$v) {
        _vm.$set(_vm.contract, "month1", $$v)
      },
      expression: "contract.month1"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("月")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.day1
    },
    model: {
      value: (_vm.contract.day1),
      callback: function($$v) {
        _vm.$set(_vm.contract, "day1", $$v)
      },
      expression: "contract.day1"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("日")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("签署了的合同号为")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.code
    },
    model: {
      value: (_vm.contract.code),
      callback: function($$v) {
        _vm.$set(_vm.contract, "code", $$v)
      },
      expression: "contract.code"
    }
  }), _vm._v(" "), _vm._m(7)], 1), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("合作品牌：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.brand
    },
    model: {
      value: (_vm.contract.brand),
      callback: function($$v) {
        _vm.$set(_vm.contract, "brand", $$v)
      },
      expression: "contract.brand"
    }
  })], 1), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("产品按照主协议交付之日起"), _c('my-content', {
    attrs: {
      "val": _vm.contract.days
    },
    model: {
      value: (_vm.contract.days),
      callback: function($$v) {
        _vm.$set(_vm.contract, "days", $$v)
      },
      expression: "contract.days"
    }
  }), _vm._v("天，乙方根据甲方实际完成销售的商品数量向甲方申请结算，双方确认无误后，乙方按主合同发票开具规定向甲方开具发票，甲方收到乙方发票后向乙方支付对应货款。")], 1)]), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("户名：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.BaccountName
    },
    model: {
      value: (_vm.contract.BaccountName),
      callback: function($$v) {
        _vm.$set(_vm.contract, "BaccountName", $$v)
      },
      expression: "contract.BaccountName"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("开户行：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.Bbank
    },
    model: {
      value: (_vm.contract.Bbank),
      callback: function($$v) {
        _vm.$set(_vm.contract, "Bbank", $$v)
      },
      expression: "contract.Bbank"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("账号：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.BaccountNum
    },
    model: {
      value: (_vm.contract.BaccountNum),
      callback: function($$v) {
        _vm.$set(_vm.contract, "BaccountNum", $$v)
      },
      expression: "contract.BaccountNum"
    }
  })], 1), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方应当在签订本协议后10日内向甲方支付商品质量和服务保证金，该保证金总金额为人民币"), _c('my-content', {
    attrs: {
      "val": _vm.contract.deposit
    },
    model: {
      value: (_vm.contract.deposit),
      callback: function($$v) {
        _vm.$set(_vm.contract, "deposit", $$v)
      },
      expression: "contract.deposit"
    }
  }), _vm._v("元。若乙方未按约定时间支付保证金的，乙方认可甲方有权自应结账款中扣除相应金额作为保证金。")], 1)]), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方退货地址：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.BreturnAddress
    },
    model: {
      value: (_vm.contract.BreturnAddress),
      callback: function($$v) {
        _vm.$set(_vm.contract, "BreturnAddress", $$v)
      },
      expression: "contract.BreturnAddress"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("联系人：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.BcontactsName
    },
    model: {
      value: (_vm.contract.BcontactsName),
      callback: function($$v) {
        _vm.$set(_vm.contract, "BcontactsName", $$v)
      },
      expression: "contract.BcontactsName"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.BcontactsPhone
    },
    model: {
      value: (_vm.contract.BcontactsPhone),
      callback: function($$v) {
        _vm.$set(_vm.contract, "BcontactsPhone", $$v)
      },
      expression: "contract.BcontactsPhone"
    }
  })], 1), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("姓名：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.AagentName
    },
    model: {
      value: (_vm.contract.AagentName),
      callback: function($$v) {
        _vm.$set(_vm.contract, "AagentName", $$v)
      },
      expression: "contract.AagentName"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("地址：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.AagentAddr
    },
    model: {
      value: (_vm.contract.AagentAddr),
      callback: function($$v) {
        _vm.$set(_vm.contract, "AagentAddr", $$v)
      },
      expression: "contract.AagentAddr"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("邮箱：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.AagentEmail
    },
    model: {
      value: (_vm.contract.AagentEmail),
      callback: function($$v) {
        _vm.$set(_vm.contract, "AagentEmail", $$v)
      },
      expression: "contract.AagentEmail"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.AagentPhone
    },
    model: {
      value: (_vm.contract.AagentPhone),
      callback: function($$v) {
        _vm.$set(_vm.contract, "AagentPhone", $$v)
      },
      expression: "contract.AagentPhone"
    }
  })], 1), _vm._v(" "), _vm._m(28), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("姓名：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.BagentName
    },
    model: {
      value: (_vm.contract.BagentName),
      callback: function($$v) {
        _vm.$set(_vm.contract, "BagentName", $$v)
      },
      expression: "contract.BagentName"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("地址：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.BagentAddr
    },
    model: {
      value: (_vm.contract.BagentAddr),
      callback: function($$v) {
        _vm.$set(_vm.contract, "BagentAddr", $$v)
      },
      expression: "contract.BagentAddr"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("邮箱：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.BagentEmail
    },
    model: {
      value: (_vm.contract.BagentEmail),
      callback: function($$v) {
        _vm.$set(_vm.contract, "BagentEmail", $$v)
      },
      expression: "contract.BagentEmail"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.BagentPhone
    },
    model: {
      value: (_vm.contract.BagentPhone),
      callback: function($$v) {
        _vm.$set(_vm.contract, "BagentPhone", $$v)
      },
      expression: "contract.BagentPhone"
    }
  })], 1), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt 21pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("7．甲方在合作期限内累计达成以下采购金额的，乙方应当按照以下标准进行返利：")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.addDomain
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _vm._l((_vm.contract.rebates), function(item) {
    return _c('p', {
      staticStyle: {
        "margin": "0pt 0pt 6pt",
        "orphans": "0",
        "text-align": "justify",
        "widows": "0"
      }
    }, [_c('span', {
      staticStyle: {
        "font-family": "华文楷体",
        "font-size": "10.5pt"
      }
    }, [_vm._v("累计采购金额达到")]), _vm._v(" "), _c('my-content', {
      attrs: {
        "val": item.money
      },
      model: {
        value: (item.money),
        callback: function($$v) {
          _vm.$set(item, "money", $$v)
        },
        expression: "item.money"
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-family": "华文楷体",
        "font-size": "10.5pt"
      }
    }, [_vm._v("元人民币，乙方给予甲方累计采购金额")]), _vm._v(" "), _c('my-content', {
      attrs: {
        "val": item.ratio
      },
      model: {
        value: (item.ratio),
        callback: function($$v) {
          _vm.$set(item, "ratio", $$v)
        },
        expression: "item.ratio"
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-family": "华文楷体",
        "font-size": "10.5pt"
      }
    }, [_vm._v("%的返利；")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeDelete(item)
        }
      }
    }, [_vm._v("删除")])], 1)
  }), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33), _vm._v(" "), _vm._m(34), _vm._v(" "), _vm._m(35), _vm._v(" "), _vm._m(36), _vm._v(" "), _vm._m(37), _vm._v(" "), _vm._m(38), _vm._v(" "), _vm._m(39), _vm._v(" "), _vm._m(40), _vm._v(" "), _c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "margin-left": "0pt",
      "width": "464.3pt"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tr', {
    staticStyle: {
      "height": "96.8pt"
    }
  }, [_c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "221.35pt"
    }
  }, [_vm._m(41), _vm._v(" "), _vm._m(42), _vm._v(" "), _vm._m(43), _vm._v(" "), _vm._m(44), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "10.5pt",
      "line-height": "115%",
      "margin": "7.8pt 0pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("签约日期：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.AsignYear
    },
    model: {
      value: (_vm.contract.AsignYear),
      callback: function($$v) {
        _vm.$set(_vm.contract, "AsignYear", $$v)
      },
      expression: "contract.AsignYear"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("年")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.AsignMonth
    },
    model: {
      value: (_vm.contract.AsignMonth),
      callback: function($$v) {
        _vm.$set(_vm.contract, "AsignMonth", $$v)
      },
      expression: "contract.AsignMonth"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("月")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.AsignDay
    },
    model: {
      value: (_vm.contract.AsignDay),
      callback: function($$v) {
        _vm.$set(_vm.contract, "AsignDay", $$v)
      },
      expression: "contract.AsignDay"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("日")])], 1)]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "221.35pt"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "10.5pt",
      "line-height": "115%",
      "margin": "7.8pt 0pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方（盖章）：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.Bsign
    },
    model: {
      value: (_vm.contract.Bsign),
      callback: function($$v) {
        _vm.$set(_vm.contract, "Bsign", $$v)
      },
      expression: "contract.Bsign"
    }
  })], 1), _vm._v(" "), _vm._m(45), _vm._v(" "), _vm._m(46), _vm._v(" "), _vm._m(47), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "10.5pt",
      "line-height": "115%",
      "margin": "7.8pt 0pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("签约日期：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.BsignYear
    },
    model: {
      value: (_vm.contract.BsignYear),
      callback: function($$v) {
        _vm.$set(_vm.contract, "BsignYear", $$v)
      },
      expression: "contract.BsignYear"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("年")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.BsignMonth
    },
    model: {
      value: (_vm.contract.BsignMonth),
      callback: function($$v) {
        _vm.$set(_vm.contract, "BsignMonth", $$v)
      },
      expression: "contract.BsignMonth"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("月")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.BsignDay
    },
    model: {
      value: (_vm.contract.BsignDay),
      callback: function($$v) {
        _vm.$set(_vm.contract, "BsignDay", $$v)
      },
      expression: "contract.BsignDay"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("日")])], 1)])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "height": "29.3pt"
    }
  }, [_c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "221.35pt"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "10.5pt",
      "line-height": "115%",
      "margin": "7.8pt 0pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("授权代表人签字：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.Adeputy
    },
    model: {
      value: (_vm.contract.Adeputy),
      callback: function($$v) {
        _vm.$set(_vm.contract, "Adeputy", $$v)
      },
      expression: "contract.Adeputy"
    }
  })], 1)]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "221.35pt"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "10.5pt",
      "line-height": "115%",
      "margin": "7.8pt 0pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("授权代表人签字：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.Bdeputy
    },
    model: {
      value: (_vm.contract.Bdeputy),
      callback: function($$v) {
        _vm.$set(_vm.contract, "Bdeputy", $$v)
      },
      expression: "contract.Bdeputy"
    }
  })], 1)])])]), _vm._v(" "), _vm._m(48), _vm._v(" "), _vm._m(49)], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px 0px 15px 0px",
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitContent()
      }
    }
  }, [_vm._v("保 存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.findEmpty()
      }
    }
  }, [_vm._v("定位未填")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.returnWindow()
      }
    }
  }, [_vm._v("返 回")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "16pt",
      "font-weight": "bold"
    }
  }, [_vm._v("购销协议之补充协议")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "15pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("本《购销协议之补充协议》（以下简称“"), _c('b', [_vm._v("本补充协议")]), _vm._v("”） 由以下双方于")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("甲方：")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("天津果敢时代国际贸易有限公司")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("的《 购销协议 》（以下简称“"), _c('b', [_vm._v("主协议")]), _vm._v("”），经双方友好协商，就主协议中的若干事项达成以下共识和一致意见：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt 21pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("1．双方同意合作品牌如下：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt 21pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("2．双方同意如下结算方式：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt 21pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("3．乙方银行账户信息如下：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方的银行账户信息如发生任何变化，应提前30日通知甲方，并提供新的银行账户信息。如因乙方未及时通知甲方而造成任何后果，由乙方承担。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt 21pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("4．为主协议及本补充协议之目的，双方同意如下保证金事项：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("甲方保证金银行账户信息如下：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("户名：【天津果敢时代国际贸易有限公司】")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("开户行：【招商银行股份有限公司天津武清支行】")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("账号：【122907366910806】")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt 21pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("5．双方同意就主协议规定退换货补充规定如下：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("在不限制甲方根据主协议享有的任何退货权利和补救办法的条件下，甲方有权要求乙方限期提取退货或更换，相关费用和风险由乙方承担，如乙方逾期不提取退货，甲方有权将退货配送至乙方如下退货地点，退货运费及风险由乙方承担。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方的退货地址如发生任何变化，应提前30日通知甲方，并提供新的退货地址。如因乙方未及时通知甲方而造成任何后果，由乙方承担。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt 21pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("6．为主协议及本补充协议之目的，双方指定如下代理人进行业务沟通：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("甲方指定的代理人：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方指定的代理人：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("一方的授权代理人信息如发生任何变化，应提前5个工作日通知另外一方，并提供新的联系人信息。如因乙方未及时通知甲方而造成任何后果，由乙方承担。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("甲方有权在应付款项中直接扣除返利金额。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("8．本补充协议是对主协议的补充，是主协议不可分割的一部分，与主协议拥有同等法律效力，主协议内容与本补充协议的约定不一致时，以本补充协议的内容确定双方的权利义务；本补充协议中未涉及的内容依据主协议履行；")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("9．本补充协议自双方盖章之日起生效，一式贰（2）份，双方各执壹（1）份，具有同等法律效力。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "center",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-style": "italic"
    }
  }, [_vm._v("[以下无正文]")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "10.5pt",
      "line-height": "115%",
      "margin": "7.8pt 0pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("甲方（盖章）：天津果敢时代国际贸易有限公司")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "10.5pt",
      "line-height": "115%",
      "margin": "7.8pt 0pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "10.5pt",
      "line-height": "115%",
      "margin": "7.8pt 0pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "10.5pt",
      "line-height": "115%",
      "margin": "7.8pt 0pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "10.5pt",
      "line-height": "115%",
      "margin": "7.8pt 0pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "10.5pt",
      "line-height": "115%",
      "margin": "7.8pt 0pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "10.5pt",
      "line-height": "115%",
      "margin": "7.8pt 0pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36b23fe6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/supplier/contract/edit/contract_2_1.vue
// module id = 513
// module chunks = 0